import { render } from "./ContactDetail.vue?vue&type=template&id=264ec5c8&scoped=true"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"

import "./ContactDetail.vue?vue&type=style&index=0&id=264ec5c8&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ec5c8"]])

export default __exports__